import React from "react";

const IArrowRounded = ({
  color = "#101010",
  width = "16",
  height = "16",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8 1.5625C9.70672 1.56449 11.343 2.24336 12.5498 3.4502C13.7566 4.65703 14.4355 6.29328 14.4375 8C14.4375 9.27314 14.0598 10.5176 13.3525 11.5762C12.6453 12.6347 11.64 13.46 10.4639 13.9473C9.28757 14.4345 7.99289 14.5619 6.74414 14.3135C5.4954 14.0651 4.34853 13.4521 3.44824 12.5518C2.54795 11.6515 1.93492 10.5046 1.68652 9.25586C1.43813 8.00711 1.5655 6.71243 2.05273 5.53613C2.53999 4.35999 3.3653 3.35475 4.42383 2.64746C5.41628 1.98438 6.57206 1.61144 7.76172 1.56738L8 1.5625ZM8 4.93848C7.85071 4.93848 7.70728 4.99714 7.60156 5.10254L5.48145 7.22363C5.37615 7.32915 5.31633 7.47203 5.31641 7.62109C5.31651 7.77013 5.37606 7.91317 5.48145 8.01855C5.58683 8.12394 5.72987 8.18349 5.87891 8.18359C6.02797 8.18367 6.17085 8.12385 6.27637 8.01855L7.4375 6.85742V10.5C7.4375 10.6492 7.49705 10.792 7.60254 10.8975C7.70803 11.0029 7.85082 11.0625 8 11.0625C8.14918 11.0625 8.29197 11.0029 8.39746 10.8975C8.50295 10.792 8.5625 10.6492 8.5625 10.5V6.85742L9.72363 8.01855C9.77585 8.0708 9.83801 8.11235 9.90625 8.14062C9.97441 8.16882 10.0473 8.18359 10.1211 8.18359C10.1949 8.18359 10.2678 8.16882 10.3359 8.14062C10.4042 8.11235 10.4663 8.0708 10.5186 8.01855C10.5708 7.96634 10.6123 7.90418 10.6406 7.83594C10.6688 7.76778 10.6836 7.69485 10.6836 7.62109C10.6836 7.54733 10.6688 7.47441 10.6406 7.40625C10.6123 7.33801 10.5708 7.27585 10.5186 7.22363L8.39844 5.10254C8.29272 4.99714 8.14929 4.93848 8 4.93848Z"
        fill={color}
        stroke={color}
        strokeWidth="0.125"
      />
    </svg>
  );
};

export default IArrowRounded;
